'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { RouteMeta } from '../../../../_components/page/RouteMeta';
import { deriveQuoteActiveTabFromPathname } from '../../../../../src/utils/quote/active-tab';
import { buildQuotePageTargeting } from '../../../../../src/utils/quote/page-targeting';

interface QuoteTabAdTargetingProps {
  symbol: string;
  isZacksApplied: boolean;
}

export default function QuoteTabAdTargeting({ symbol, isZacksApplied }: QuoteTabAdTargetingProps) {
  const pathname = usePathname();
  const activeTab = deriveQuoteActiveTabFromPathname(pathname);
  const targeting = useMemo(
    () => buildQuotePageTargeting(symbol, activeTab, { isZacksApplied }),
    [symbol, activeTab, isZacksApplied],
  );

  return <RouteMeta pageTargeting={targeting} />;
}
